import React, { useState } from 'react'
import { usePotential } from '../PotentialContext/PotentialContext'
import PotentialLabel from '../PotentialLabel/PotentialLabel';
import { isValidDecimalInput } from '../../../helper/helpers';
import { handleValueLabelChange, removeLeadingZeros } from '../utils/helpers';
import PotentialInput from '../PotentialInput/PotentialInput';

const NumDistributionYears = ({value, infoText}) => {
    const { updateUserInfo } = usePotential();
    const [distributionYears, setDistributionYears] = useState(value)

    const handleOnChange = (e) => {
        let value = e.target.value;
        value = removeLeadingZeros(value);
        const isValidDecimal = isValidDecimalInput(value);
        if(!isValidDecimal) return;

        setDistributionYears(value);

        const years = value === '' ? 0 : parseFloat(value);

        updateUserInfo({distributionYears: years});
    }

    return (
        <PotentialLabel 
            label={"Distribution Years"}
            value={handleValueLabelChange(distributionYears)}
            infoText={infoText}
        >
            <PotentialInput value={distributionYears} handleOnChange={handleOnChange} />
        </PotentialLabel>
    )
}

export default NumDistributionYears